var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { cx } from '@emotion/css';
import React from 'react';
import * as css from './css';
import { Tab, isTabComponent } from './tab';
export var TabList = function (_a) {
    var children = _a.children, className = _a.className, onChange = _a.onChange, variant = _a.variant, tabListType = _a.tabListType, props = __rest(_a, ["children", "className", "onChange", "variant", "tabListType"]);
    var defaultSelected = React.useMemo(function () { return React.Children.toArray(children).findIndex(function (child) {
        return isTabComponent(child) && child.props.selected;
    }); }, []);
    var _b = React.useState(defaultSelected !== -1 ? defaultSelected : 0), selectedIndex = _b[0], setSelectedIndex = _b[1];
    var previousSelectedIndex = React.useRef(0);
    var onClickTab = function (index, panelId) {
        if (index !== selectedIndex) {
            previousSelectedIndex.current = selectedIndex;
            setSelectedIndex(index);
            onChange === null || onChange === void 0 ? void 0 : onChange(panelId);
        }
    };
    var selectedTab = React.Children.toArray(children)[selectedIndex];
    var tabListStyle = React.useMemo(function () { return css.getTabListStyle({ variant: variant }); }, [variant]);
    var tabTypeStyle = React.useMemo(function () { return css.getTabStyle({ tabListType: tabListType }); }, [tabListType]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", __assign({}, props, { role: "tablist", className: cx(css.tabList, tabListStyle, className) }), React.Children.map(children, function (child, index) {
            if (!isTabComponent(child)) {
                throw new TypeError("Expecting child at index " + index + " to be of type Tab");
            }
            var _a = child.props, label = _a.label, onClick = _a.onClick, tabProps = __rest(_a, ["label", "onClick"]);
            var tabButtonStyle = css.getTabButtonStyle(previousSelectedIndex.current, index, selectedIndex);
            return React.createElement(Tab, __assign({}, tabProps, { key: label, label: label, className: cx(tabButtonStyle, tabTypeStyle, tabProps.className), selected: index === selectedIndex, onClick: function (panelId) {
                    onClickTab(index, panelId);
                    onClick === null || onClick === void 0 ? void 0 : onClick(panelId);
                } }),
                React.createElement("div", { className: tabButtonStyle + "-underline" }));
        })),
        React.createElement("div", { role: "tabpanel" }, isTabComponent(selectedTab) ? selectedTab.props.children : null)));
};
